export default __webpack_public_path__ + "static/media/move-material-1.50210693.webp";